<template lang="pug">
    .container
        .card
            .card__cover(:class="'card__cover-' + image_position")
                .card__image
                    img(v-bind="image.default").default
                    img(v-bind="image.mobile").mobile
            .card__content(:style="{'background': main_color}", :class="'card__content-' + textarea_shape")
                .card__contentInner
                    .card__textarea
                        .card__header(v-text="header", :class="localeClass")
                        .card__body(v-html="body", :class="localeClass")
                    .card__link_container
                        DynamicLink(v-if="btn_url" :to="btn_url" v-text="btn" class="card__link")
</template>

<script>
    import DynamicLink from './DynamicLink';

    export default {
        name: "WidgetCard",
        components: {DynamicLink},
        props: {
            image: Object,
            textarea_shape: String,
            image_position: String,
            main_color: String,
            header: String,
            body: String,
            btn: String,
            btn_url: String,
            locale: String
        },
        computed: {
            localeClass() {
                const locale = this.locale === "en" ? "english" : "chinese";
                return {
                    [locale]: true
                }
            }
        }
    };
</script>

<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    @import "../../node_modules/bootstrap/scss/grid"
    $color-text: #333333

    .card
        position: relative
        width: 100%
        @include media-breakpoint-down(lg)
            padding-left: 0
            padding-right: 0
            margin-top: 1rem
            margin-bottom: 1rem

        &__cover
            &-left
                text-align: left

                + .card__content
                    right: 0

            &-right
                text-align: right

                + .card__content
                    left: 0

        &__image
            display: inline-block

            img
                height: 510px
                &.mobile
                    display: none
            @include media-breakpoint-down(lg)
                width: 100%
                img
                    height: auto
                    width: 100%
                    &.default
                        display: none
                    &.mobile
                        display: inline-block

        &__content
            position: absolute
            top: 0
            height: 100%
            @include media-breakpoint-down(lg)
                position: relative

            &-rectangle
                width: 65%
                @include media-breakpoint-down(lg)
                    width: 100%

            &-square
                width: 35%
                @include media-breakpoint-down(lg)
                    width: 100%

            &-half
                width: 50%
                @include media-breakpoint-down(lg)
                    width: 100%

        &__contentInner
            display: table
            // max-width: 400px
            width: 90%
            height: 100%
            padding: 5rem 3rem
            margin: 0 auto
            color: #666666
            @include media-breakpoint-down(lg)
                padding: 1rem 0

        &__textarea
            /*display: table-cell*/
            /*vertical-align: middle*/
            @include media-breakpoint-down(lg)
                padding-bottom: 1rem

        &__header
            font-variant: small-caps
            font-weight: bold
            font-size: 2.4rem
            line-height: 120%
            &.english
                font-size: 1.8rem
            @include media-breakpoint-down(lg)
                margin-top: 1rem
                font-size: 1.56rem

        &__body
            &.english
                line-height: 1.25
            margin-top: 1.5rem
            font-size: 1.25rem
            @include media-breakpoint-down(lg)
                font-size: 0.875rem
                margin-top: 1rem
                margin-bottom: 1rem

        &__link_container
            a
                font-size: 18px
            position: absolute
            bottom: 0
            padding-bottom: 3.5rem
            @include media-breakpoint-down(lg)
                position: static
                padding-bottom: 1rem

        &__link
            padding-right: 2rem
            transition: padding-right .25s

            &:hover
                padding-right: 2.35rem

            background: url('../assets/home/icon__grayArrow-right.png') right center no-repeat
            font-size: 1.25rem
            color: #666666
            @include media-breakpoint-down(lg)
                padding-right: 1rem
                &:hover
                    padding-right: 1.2rem
                background-size: auto 60%
                font-size: 0.875rem
</style>
